import React, { useState } from 'react';

import { IntegrationContext } from '../context/integration';
import { SelfServiceLayout } from './layout/SelfServiceLayout';

type SelfServiceIntegrationProps = {
  allowedSources: IntegrationContext['sourceFilter'];
  template: IntegrationContext['template'];
  mappingFields: IntegrationContext['mappingFields'];
  name: IntegrationContext['integrationName'];
  subTitle: string;
  onClose: () => void;
};

export const SelfServiceIntegration: React.FC<SelfServiceIntegrationProps> = ({
  allowedSources,
  template,
  mappingFields,
  name,
  subTitle,
  onClose,
}) => {
  const [formEnabled, setFormEnabled] = useState(true);

  return (
    <IntegrationContext.Provider
      value={{
        sourceFilter: allowedSources,
        template,
        mappingFields,
        integrationName: name,
        formEnabled,
        setFormEnabled,
      }}
    >
      <SelfServiceLayout onClose={onClose} subTitle={subTitle} />
    </IntegrationContext.Provider>
  );
};
